import React, { useState, useEffect } from 'react'
import { Paper } from '@mui/material'
import Navbar from '../common/navbar'
import Footer from '../common/footer'
import Avatar from '@mui/material/Avatar';
import { useLocation } from 'react-router-dom';
import { deepPurple } from '@mui/material/colors';
import { Link } from 'react-router-dom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import api from '../../API/api';
import CreateIcon from '@mui/icons-material/Create';
import AddAlumniForm from '../../AdminPages/form/addAlumniForm';
import FormDialog from '../../AdminPages/panel/modal';



const htmlToFormattedText = require("html-to-formatted-text");

const StudentDash = () => {
    const location = useLocation();

    // console.log(location, 'location');
    const [user, setUser] = useState(location.state);
    const [blogs, setBlogs] = useState([]);
    const [open, setOpen] = useState(false);
    const [hide, setHide] = useState(true);
    const [dash , setDash] = useState(true);
    const [disabled , setDisabled] = useState(true);

    const handleClickOpen =()=> {setOpen(true); }

    const handleClose =()=> setOpen(false);

    function stringAvatar(name) {
        return {
            sx: {
                bgcolor: stringToColor(name),
                width: 60, height: 60
            },
            children: `${name?.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }
    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }
    const handleDateStudent = () => {
        let date = new Date().getFullYear();
        // console.log(date - parseInt(user.batch),'check date1');
        if ( date - parseInt(user.batch)  > 3) {
            // console.log(date - parseInt(user.batch),'check date');
            setDash(false);
        }
    } 



    useEffect(() => {
        getBlogs()
    }, []);

    useEffect(() => {
        handleDateStudent();
    },[user?.batch])

    const getBlogs = () => {
        api.getBlogs().then((res) => {
            // console.log(res);
            setBlogs(res.data.blogs)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    const handleOpen = () => {

    }


    return (
        <>
            <Navbar />
            <div className='student-dash'>
                <FormDialog
                    open={open}
                    handleClose={handleClose} 
                    handleClickOpen={handleClickOpen} 
                    title='Edit Profile'
                    form={
                    <AddAlumniForm 
                        from='public'
                        handleClose={handleClose}
                        handleClickOpen={handleClickOpen}
                        step={3}
                        hide={hide} setHide={setHide} dash={dash}
                        user={user} disabled={disabled}
                    />
                }
                />
                <div className='container-fluid'>
                    <Paper>
                        <div className='header px-3 pt-3'>
                            <h4>Dashboard</h4>
                        </div>
                        <div className='row'>
                            <div className='col-md-3'>
                                <div className='left'>
                                    <Paper elevation={3} className='p-3'>
                                        <div className=''>
                                            {/* {
                                                user?.name &&
                                                <Avatar
                                                    {...stringAvatar(`${user?.name}`)}
                                                />
                                            } */}
                                            <div className='d-flex gap-2'>
                                                <Avatar
                                                    sx={{ bgcolor: deepPurple[500], width: 56, height: 56 }}
                                                >{user?.name[0]}</Avatar>
                                                <div>
                                                    <h4>{user?.name}</h4>
                                                    <div className='d-flex gap-3'>
                                                        <h6>{user?.email != 'null' ? user?.email : ''}</h6>
                                                        {/* <>{user?.dob}</   h6> */}
                                                    </div>
                                                </div>
                                                <div className='ms-auto'>
                                                    <button onClick={handleClickOpen} type="button" className='bg-none border-0'>
                                                        <CreateIcon />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p></p>
                                            {/* <p>Batch : {user?.id}</p> */}
                                            <p>Batch : {user?.batch}</p>
                                            <p>Admission Year : {user?.admissionYear}</p>
                                            <p>Enrollment Id : {user?.enrollment}</p>
                                            <p>Registration Id : {user?.registration}</p>
                                            <p>Date of Birth : {user?.dob}</p>
                                        </div>
                                    </Paper>
                                </div>
                            </div>
                            <div className='col-md-9'>
                                <div className='right'>
                                    <Paper elevation={3} className='p-3'>
                                        <h3>Your Blogs</h3>

                                        <div className='blogs'>
                                            <div className='row p-3'>

                                                {blogs && blogs.filter((el) => el.author_id == user?.id).map((b) =>
                                                (
                                                    <div className="col-md-4 p-2">
                                                        <Paper elevation={3}>
                                                            <div>
                                                                <img src={`${process.env.REACT_APP_BACKEND}blogs/cover/${b.cover}`} className='col-12' alt={b.title} />
                                                            </div>
                                                            <div className='m-2 p-2'>

                                                                <div>
                                                                    <small> <CalendarMonthIcon fontSize='small' /> {b.date} ({b.isApprove === 0 ? <span className='text-danger'>Not Approved</span> : <span className='text-success'>Approved</span>})</small>
                                                                </div>
                                                                <div>
                                                                    <Link to={`/blogs/${b.slug}`}><b> {b.title} </b></Link>
                                                                </div>
                                                                <div className='my-2'>
                                                                    <small>
                                                                        {htmlToFormattedText(b.details).slice(0, 150)} ...
                                                                        <Link>Read more..</Link>
                                                                    </small>
                                                                </div>
                                                                <div>

                                                                </div>
                                                            </div>
                                                        </Paper>
                                                    </div>
                                                ))}


                                                {blogs.filter((el) => el.author_id == user?.id).length === 0 && 'Not Found Any Blogs'}

                                            </div>
                                        </div>
                                    </Paper>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default StudentDash;